import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

interface IScreenCardWrapperProps extends PropsWithChildren {}

export const ScreenCardWrapper = ({
  children,
}: IScreenCardWrapperProps): JSX.Element => {
  return (
    <Stack
      sx={{
        width: {
          xs: `100%`,
          sm: 590,
        },

        '.MuiCardContent-root': {
          padding: { xs: 2, sm: 3 },
        },
      }}
    >
      {children}
    </Stack>
  );
};
